import { useRef, useState } from 'react';
import { submitAROnlyAccessory } from '../../helper/helper';
import toast from 'react-hot-toast';
//import CustomButton from '../../components/ui/Button/Button';
import { readFile, readSkus } from './pdfUtils';
import { readRQ ,HUP_RQ_Code,ACT_POSTPAID_RQ_Code,ACT_PREPAID_RQ_Code } from './fileTempates';
// import { Button } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CustomButton from '../../components/ui/Button/Button';

//import { useTheme } from "@mui/material/styles";
//import { useMediaQuery } from '@mui/material';

const AccessoryBlock = ({username ,manualSkuList,eventinfoforCis}) => {
  const [rqAccessoryResult, setRqAccessoryResult] = useState('');
  const rqRefOnlyAccessory = useRef(null);
 // const theme = useTheme();
  //const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  //const ismediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  // function checkStringForWords(str) {
  //   // Regular expression to match "Postpaid" or "postpaid"
  //   const postpaidRegex = /postpaid/i; // 'i' makes it case insensitive

  //   // Regular expression to match "Hardware Upgrade"
  //   const hardwareUpgradeRegex = /Hardware Upgrade/;

  //   // Check if both patterns are present in the string
  //   return postpaidRegex.test(str) || hardwareUpgradeRegex.test(str);
  // }


  async function readRqOnlyAccessoryFile(event) {
    const file = event.target.files[0];
    // Validating File type

    if (!file) {
      return;
    }
    const { result } = await readFile(event);

    // Validate content for RQ file
    if (
      !result.startsWith('Sale Invoice :') ||
      !result.includes('Thanks for your Business!') ||
      [HUP_RQ_Code, ACT_POSTPAID_RQ_Code, ACT_PREPAID_RQ_Code].some(code => result.includes(code))
    ) {
      toast.error('The uploaded file does not appear to be a valid RQ file for Only Accessory.');
      setRqAccessoryResult('');
      return;
    }
    setRqAccessoryResult(result);
  }

  async function rq4DataExtractionOnlyAccessory(rqresult) {
    // function saleInvoiceExtraction(rqresult) {
    //   const pattern = /Sale Invoice : ([A-Z0-9]+)/;
    //   const match = pattern.exec(rqresult);
    //   let extractedText = '';
    //   if (match && match[1]) {
    //     extractedText = match[1];
    //   }
    //   return extractedText;
    // }
 
    // const timePattern = /\b(0?[1-9]|1[0-2]):[0-5][0-9]\s?[APap][Mm]\b/g;

    // // Use the match method to find all matches
    // const times = rqresult.match(timePattern);


    let {storeInvoice,saleInvoice,tenderedDate,time,salesPerson} = readRQ(rqresult)
    let values = {
      storeInvoiceOA: storeInvoice,
      saleInvoiceOA: saleInvoice,
      tenderedDateOA: tenderedDate,
      timeOA: time,
      salesPerson: salesPerson,
      // connectionType: checkStringForWords(rqresult),
    };

    return values;
  }

  const onTypeChangeOnlyAccessoryFile = async (e) => {
    e.preventDefault();
    if (rqAccessoryResult.length > 0) {
      const { accessories: attachedAccOnlyAccessory, discountInfo:discountInfoOnlyAccessory = {}, newAccessoriesList } = readSkus(manualSkuList, rqAccessoryResult);
      let totalCostOnlyAccessory = 0;
      let totalMsrpOnlyAccessory = 0;
      let totalDiscountOnlyAccessory = 0;
      attachedAccOnlyAccessory.forEach((item) => {
        const [ /* productName */, , cost, msrp, , , uniqueSkuKey] = item;
        totalCostOnlyAccessory += cost;
        totalMsrpOnlyAccessory += msrp;
        if (discountInfoOnlyAccessory[uniqueSkuKey] && discountInfoOnlyAccessory[uniqueSkuKey].discount) {
          totalDiscountOnlyAccessory += discountInfoOnlyAccessory[uniqueSkuKey].discount;
        }
      });
      let aaDataOnlyAccessory = {
        cost: totalCostOnlyAccessory,
        msrp: totalMsrpOnlyAccessory,
        discount: totalDiscountOnlyAccessory,
      };

      const { storeInvoiceOA, saleInvoiceOA, tenderedDateOA, timeOA, salesPerson } =
        await rq4DataExtractionOnlyAccessory(rqAccessoryResult);
      const attachmentRateOnlyAccessory = {
        storeInvoiceOA,
        saleInvoiceOA,
        tenderedDateOA,
        timeOA,
        aaDataOnlyAccessory,
        attachedAccOnlyAccessory,
        salesPerson,
        username: username || localStorage.getItem('username'),
      };
    // Was Failing to diferentiate between Only ACC or AtachACC RQ 
      // if (!connectionType) {
        submitAROnlyAccessory({
          attachmentRateOnlyAccessory,
          tenderedDateOA,
          saleInvoiceOA,
        ...(  eventinfoforCis
      && {
          // eventName: eventinfoforCis?.id || '',
          // eventDate: eventinfoforCis?.date || '',
          event_id: eventinfoforCis?.id,
        }),
        newAccessoriesList

        }).catch((err) => {
          rqRefOnlyAccessory.current.value = null;
          setRqAccessoryResult('')
        }).then(() => {
          setRqAccessoryResult('')
          rqRefOnlyAccessory.current.value = null;
        });
        
    } else {
      toast.error('Choose a RQ file before clicking Upload Button.');
    }
  };
  return (
    <div className="accessoryBlock">
      <div className="block">
        <div className="top-block">
          <h4 className="">Accessory Only</h4>
        </div>

        <div className="bottom-block">
          {/*  <label htmlFor="rq4" className="custom-file-label">Choose RQ4 Accessory Invoice</label>
           */}
          <input
            onChange={readRqOnlyAccessoryFile}
            ref={rqRefOnlyAccessory}
            accept=".pdf"
            multiple={false}
            type="file"
            id="rq4"
            name="rq4"
          />
        </div>
      </div>
      <div className="bottom">
        <CustomButton
          btnLabel="Upload"
          buttonType='success'
          onClick={onTypeChangeOnlyAccessoryFile}
          customIcon={<CloudUploadIcon />}
          type="submit"
          disabled={!rqAccessoryResult}
        />
        
      </div>
    </div>
  );
};

export default AccessoryBlock;
